import React, { createContext, useContext, useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ProCtx = createContext(null);

export const ProProvider = ({ children }) => {
  const { user } = useAuth();
  const [pro, setPro] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) { setPro(null); return; }
    setLoading(true);
    try {
      const { data } = await api.get("/payments/me/pro");
      setPro(data);
    } finally { setLoading(false); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <ProCtx.Provider value={{ pro, isPro: !!pro?.is_pro, loading, refresh }}>
      {children}
    </ProCtx.Provider>
  );
};

export const usePro = () => {
  const ctx = useContext(ProCtx);
  if (!ctx) throw new Error("usePro must be inside ProProvider");
  return ctx;
};
